import { render, staticRenderFns } from "./auth-role-index.vue?vue&type=template&id=6e7790d6&scoped=true"
import script from "./auth-role-index.vue?vue&type=script&lang=js"
export * from "./auth-role-index.vue?vue&type=script&lang=js"
import style0 from "./auth-role-index.vue?vue&type=style&index=0&id=6e7790d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7790d6",
  null
  
)

export default component.exports